module.exports = __webpack_public_path__ + "img/tiku.4b7ba852.png";